import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import ReportingSection from "../../components/pages/reporting/ReportingSection";

export default function Reporting() {
    return (
        <PageContainerAuth section="reporting" pageTitle="Reporting">
            <ReportingSection />
        </PageContainerAuth>
    );
}